export default {
	title: "",
	subtitle: "Example 1: Pay-In - BRL to USD",
	path: "example_transaction_payin",
	paragraphs: [
		"The following example simulates a pay-in transaction where your customer is charged 1,000 BRL, sends the funds to a FacilitaPay bank account in Brazil, and the amount is later converted to USD and wired to a foreign USD bank account.",
		"This step is optional — you can simply share the bank details of the FacilitaPay bank account in Brazil that we opened for your exclusive use you with your customers. Once they complete any bank transfer, we’ll automatically notify you with a transaction ID generated by our API. Note: The customer must be registered in advance so we can properly identify the incoming funds.",
		"If you prefer to create the transaction before the customer sends the funds, you can do so by making this request. The payload format is the same for payments in Mexico, Colombia, and other countries using local currencies, with the exception of the 'currency' and 'from_bank_account_id' fields — these must match the respective country and currency.",
		"For transactions in Chile, the value field must not contain decimal places. Example: use '15000' instead of '15000.00'",
		"To correctly set the 'from_bank_account_id', go to the 'Bank Accounts' page in the portal and look under FacilitaPay cash_in accounts. Select the account that matches the currency you intend to use. This account will be used for all pay-in transactions in this field."
	],
	image: {
		path: "/static/diagrams/transactionSend.png",
		description: "Pay-in webhooks flow"
	},
	request: {
		payload: {
			"transaction": {
				"currency": "BRL",
				"exchange_currency": "USD",
				"value": "1000.00",
				"from_bank_account_id": "97313a02-bbbb-4341-bb2c-3602d185d926",
				"to_bank_account_id": "766eadfc-f020-4d2a-bed3-c9a95623ed24",
				"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21"
			}
		},
		responses: {
			"data": {
				"value": "1000.00",
				"to_bank_account": {
					"routing_number": null,
					"pix_info": null,
					"owner_name": "nome",
					"owner_document_type": null,
					"owner_document_number": "doc",
					"owner_company": {
						"social_name": "Company Test",
						"id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2",
						"document_type": "tax_id",
						"document_number": "21958642819"
					},
					"nickname": null,
					"intermediary_bank_account": null,
					"id": "766eadfc-f020-4d2a-bed3-c9a95623ed24",
					"iban": null,
					"currency": "USD",
					"branch_number": null,
					"branch_country": null,
					"bank": {
						"swift": "swift test",
						"name": "International Bank Test",
						"ispb": null,
						"id": "dab1d4c3-a5a7-4ffa-bab9-b1cc155081c0",
						"country": null,
						"code": null
					},
					"account_type": "conta-corrente",
					"account_number": "12356",
					"aba": null
				},
				"subject_is_receiver": false,
				"subject": {
					"updated_at": "2025-07-09T17:19:48.174209",
					"status": "approved",
					"social_name": "John Doe",
					"rfc_pf": null,
					"required_clearance_level": 1,
					"references": [],
					"phone_number": "99812-1212",
					"phone_country_code": "55",
					"phone_area_code": "18",
					"net_monthly_average_income": "4000.00",
					"inserted_at": "2021-03-11T20:13:17.729215",
					"id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
					"fiscal_country": "BR",
					"email": "joaquim@email.com",
					"document_type": "cpf",
					"document_number": "01234567890",
					"clearance_level": 2,
					"birth_date": "2015-04-01",
					"address_street": "Rua Barão do Rio Branco",
					"address_state": "SP",
					"address_postal_code": "16201220",
					"address_number": "310",
					"address_neighborhood": null,
					"address_country": "BR",
					"address_complement": "Apt. 44 A",
					"address_city": "Birigui"
				},
				"status": "wired",
				"source_name": "John Doe",
				"source_document_type": "cpf",
				"source_document_number": "05069869183",
				"subject_id": "deb1a9eb-39d0-4d3d-ab30-bee5406d8e21",
				"inserted_at": "2021-04-29T21:51:51.648253",
				"id": "00b8a279-38c0-4764-9c41-87cf0a8a529f",
				"from_credit_card": null,
				"from_bank_account": {
					"routing_number": null,
					"owner_name": "FACILITA PAGAMENTOS S/A",
					"owner_document_type": "cnpj",
					"owner_document_number": "10789035000105",
					"nickname": null,
					"intermediary_bank_account_id": null,
					"id": "97313a02-bbbb-4341-bb2c-3602d185d926",
					"iban": null,
					"currency": "BRL",
					"branch_number": "0001",
					"branch_country": "BRA",
					"bank": {
						"swift": "PLURBRRJ",
						"name": "Facilita Bank S.A.",
						"ispb": "10789035",
						"id": "292c1958-4926-4c7d-8550-6ce9c0952552",
						"country": "BRA",
					},
					"account_type": "conta-corrente",
					"account_number": "3467-3",
					"aba": null
				},
				"for_exchange": true,
				"exchanged_value": "167.01",
				"exchange_under_request": false,
				"exchange_currency": "USD",
				"estimated_value_until_exchange": false,
				"currency": "BRL",
				"cleared": true,
				"bank_transaction": {
					"wire_id": "6fe36590-6c1a-4e86-9998-edcc4b54c94b",
					"value": "1000",
					"spei_reference": null,
					"spei_concepto_de_pago": null,
					"source_type": "WIRE",
					"source_name": "John Doe",
					"source_id": null,
					"source_document_type": "cpf",
					"source_document_number": "05069869183",
					"source_description": "CREDITO POR TED",
					"source_branch": "1142",
					"source_bank_ispb": null,
					"source_bank": "033",
					"source_account": "130013844",
					"movement_date": "2025-07-09",
					"iof_value": "3.80",
					"inserted_at": "2025-07-09T17:50:10.137550",
					"id": "6c763e54-d819-47b8-9d2b-a06380c1e4af",
					"exchanged_value": "167.01",
					"exchange_rate_spot": "5.906",
					"exchange_rate": "5.98773",
					"exchange_id": "7fc49fb2-40b0-4558-bb1b-89829fde0241",
					"exchange_currency": "USD",
					"exchange_approved": true,
					"currency": "BRL"
				}
			}
		}
	},
	parameterPayload: [
		{
			name: "transaction",
			type: "object",
			required: true,
			description: "Transaction data containing at least the following required values:"
		},
		{
			name: "transaction.currency",
			type: "string",
			required: true,
			description: "Currency of the amount to be sent to FacilitaPay or deducted from an internal bank account balance (ISO 4217 format)"
		},
		{
			name: "transaction.value",
			type: "string",
			required: true,
			description: "Amount to be sent to FacilitaPay (PIX / TED / WIRE) or deducted from an internal bank account balance"
		},
		{
			name: "transaction.exchange_currency",
			type: "string",
			required: true,
			description: "The \"destination\" currency also in (ISO 4217 format). It must match the currency of the bank account set in the 'to_bank_account_id' field"
		},
		{
			name: "transaction.from_bank_account_id",
			type: "string",
			required: true,
			description: "In this example is the ID of a Bank Account from FacilitaPay in Brazil. This is NOT your customer's account."
		},
		{
			name: "transaction.to_bank_account_id",
			type: "string",
			required: true,
			description: "In this example is the ID of a foreign bank account of the partner (for this case, a USD bank account)."
		},
		{
			name: "transaction.subject_id",
			type: "string",
			required: true,
			description: "ID of your customer that will make the payment."
		}
	],
	troubleshooting: {
		title: 'Common Mistakes',
		messages: [{
			code: {
				"from_bank_account_id": ["account currency does not match transaction currency"]
			},
			solution: 'Provide accounts with matching currencies as in the request.'
		}]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPayInExample.js